<template><div><h1>VUX V2.1.1Rc.1 发布日志</h1>
<h2><a href="/zh-CN/components/cell-box.html">CellBox</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复 label 未正确设置 labelMarginRight #977 @wg5945</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复 `overflow-scrolling` 设置逻辑遗漏问题 #311 @linhaobin</li>
</ul>
<h2><a href="/zh-CN/components/radio.html">Radio</a></h2>
<ul><li>[feature] 支持左侧图标</li>
</ul>
<h2><a href="/zh-CN/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] 修复路由间有过渡动画导致顶部距离计算不准确的问题</li>
<li>[enhance] 设置 z-index 避免被覆盖 #976 @olymk</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[fix] 修复 less 变量 @tabbar-text-active-color #982 @marsal1212</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.1-210.vue?3b45e9c2